import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import TransferStrip from '../components/TransferStrip';
import TransferSlic from '../components/TransferSlic';
import { clearLineTransfers, clearSelectedLine, fetchLine } from '../../../store/slices/line';
import { makeStyles } from '@material-ui/core';

const TransferRequest = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const classes = useStyles();

  const screenIsMounted = React.useRef();

  const cdLinhaFromPath = React.useRef(match.params.cdLinha).current;
  const isStrip = useSelector(state => state.line.isStrip);
  const selectedLine = useSelector(state => state.line.selected);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    screenIsMounted.current = true;
    (async () => {
      setLoading(true);
      const promisses = [];
      if (!selectedLine) promisses.push(dispatch(fetchLine(cdLinhaFromPath)));
      if (promisses.length > 0) await Promise.all(promisses);
      if (screenIsMounted.current) setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    return () => {
      screenIsMounted.current = false;
      dispatch(clearLineTransfers());
      dispatch(clearSelectedLine());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isStrip ? (
        <TransferStrip classes={classes} cdLinha={cdLinhaFromPath} loading={loading} setLoading={setLoading} />
      ):(
        <TransferSlic classes={classes} cdLinha={cdLinhaFromPath} loading={loading} setLoading={setLoading} />
      )}
    </>
  );
};

const useStyles = makeStyles(theme => ({
  addButton: {
    borderRadius: '25px',
    color: theme.palette.primary.contrastText,
  },
  subtitle: {
    borderBottom: '1px solid #ccc',
    paddingBottom: '5px',
    color: '#666'
  }
}));

export default TransferRequest;
